const size = {
  mobileS: '767px',
  /* mobileM: '37.5rem',
  mobileL: '42.5rem',
  tablet: '76.8rem',
  laptop: '102.4rem',
  laptopL: '144.0rem',
  desktop: '256.0rem' */
}

export const device = {
  mobileS: `(max-width: ${size.mobileS})`,
};